import * as yup from "yup";
import { IUpdatePassenger } from "models/user";

const updatePassengerValidator: yup.ObjectSchema<IUpdatePassenger> = yup.object({
  first_name: yup.string().required("First name is required"),
  last_name: yup.string().required("Last name is required"),
  phone: yup.string().required("Phone number is required"),
  email: yup.string().email("Invalid email").optional(),
  image: yup.string().optional(),
});

export default updatePassengerValidator;
